function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const h = hex.replace('#', '');
  if (!/^[0-9A-F]{3,6}$/i.test(h)) {
    return null;
  }
  const hexValue = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  const b = parseInt(hexValue, 16);
  return {r: (b >> 16) & 255, g: (b >> 8) & 255, b: b & 255};
}

function luminance(hex: string): number {
  const rgb = hexToRgb(hex);
  if (!rgb) return 0;
  const {r, g, b} = rgb;
  const s = [r, g, b].map(v => {
    const x = v / 255;
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2];
}

function getColorValue(color: string, element: HTMLElement): string {
  if (color.startsWith('var(')) {
    const varName = color.replace('var(', '').replace(')', '');
    return getComputedStyle(element).getPropertyValue(varName).trim();
  }
  return color;
}

export function getContrastingTextColor(bg: string, element: HTMLElement): string {
  const hexColor = getColorValue(bg, element);
  if (!hexColor) return '#0F172A'; // Default to dark text
  return luminance(hexColor) < 0.5 ? '#FFFFFF' : '#0F172A';
}
